import { lazy, Suspense } from "react"
import { Route, Routes } from "react-router"

import PageSeo from "@/app/seo/PageSeo"
import { Skeleton } from "@/components/ui/shadcn/skeleton"

const DefaultLayout = lazy(() => import("../layouts/DefaultLayout"))
const Home = lazy(() => import("../pages/Home/Home"))
const NotFound = lazy(() => import("../pages/NotFound/NotFound"))
const CategoryListPage = lazy(() => import("../pages/CategoryListPage/CategoryListPage"))
const ProductPage = lazy(() => import("../pages/ProductPage/ProductPage"))
const SearchPage = lazy(() => import("../pages/SearchPage/SearchPage"))
const AboutPage = lazy(() => import("../pages/AboutPage/AboutPage"))
const AboutCompany = lazy(() => import("../pages/AboutPage/components/AboutCompany"))
const TermsOfUse = lazy(() => import("../pages/AboutPage/components/TermsOfUse"))
const PrivacyPolicy = lazy(() => import("../pages/AboutPage/components/PrivacyPolicy"))
const AccountPage = lazy(() => import("../pages/AccountPage/AccountPage"))
const MyOrders = lazy(() => import("../pages/AccountPage/components/MyOrders"))
const Favorites = lazy(() => import("../pages/AccountPage/components/Favorites"))
const AccountSettings = lazy(() => import("../pages/AccountPage/components/AccountSettings"))
const OrderDetails = lazy(() => import("../pages/AccountPage/components/OrderDetails"))
const HomeDemoPage = lazy(() => import("../pages/ComponentDemoPage/HomeDemoPage"))
const CartPage = lazy(() => import("../pages/ComponentDemoPage/DemoCartPage"))
const CsspPage = lazy(() => import("../pages/CsspPage/CsspPage"))
const ProductCollectionPage = lazy(() => import("../pages/ProductCollectionPage/ProductCollectionPage"))
const ProductCatalogDemoPage = lazy(() => import("../pages/ComponentDemoPage/ProductCatalogDemoPage"))
const ProductSearchDemoPage = lazy(() => import("../pages/ComponentDemoPage/ProductSearchDemoPage"))

const ScaenaRouter: React.FC = () => {
   return (
    <Suspense fallback={<RouteLoadingFallback />}>
      <Routes>
        <Route path="/ssp" element={<CsspPage></CsspPage>}></Route>
        <Route path="/" element={<HomeDemoPage></HomeDemoPage>}></Route>
        <Route path="/cart" element={<CartPage></CartPage>}></Route>
        <Route path="/product/:refKey" element={<ProductPage></ProductPage>}></Route>
        <Route path="/category/:refKey" element={<CategoryListPage></CategoryListPage>}></Route>
        <Route path="/search" element={<SearchPage></SearchPage>}></Route>
        <Route path="/collections/popular" element={<ProductCollectionPage collection="popular" />}></Route>
        <Route path="/collections/new" element={<ProductCollectionPage collection="new" />}></Route>
        <Route path="/demo/catalog" element={<ProductCatalogDemoPage />}></Route>
        <Route path="/demo/search" element={<ProductSearchDemoPage />}></Route>
        <Route element={<DefaultLayout></DefaultLayout>}>
            <Route path="old" element={<Home></Home>}></Route>
            <Route path="about" element={<AboutPage></AboutPage>}>
                <Route index element={<AboutCompany></AboutCompany>}></Route>
                <Route path="terms" element={<TermsOfUse></TermsOfUse>}></Route>
                <Route path="privacy" element={<PrivacyPolicy></PrivacyPolicy>}></Route>
            </Route>
            <Route path="profile" element={<AccountPage></AccountPage>}>
              <Route index element={<MyOrders></MyOrders>}></Route>
                <Route path="favorites" element={<Favorites></Favorites>}></Route>
                <Route path="orders/:id" element={<OrderDetails></OrderDetails>}></Route>
                <Route path="settings" element={<AccountSettings></AccountSettings>}></Route>
            </Route>
            <Route path="*" element={<NotFound></NotFound>}></Route>
        </Route>
      </Routes>
    </Suspense>
   )
}

const RouteLoadingFallback = () => (
  <div data-scaena-ui className="grid min-h-screen place-items-center bg-surface px-4" role="status" aria-label="Загрузка страницы">
    <PageSeo title="Загрузка — КЦ Авто" description="Загрузка страницы КЦ Авто." canonicalPath={window.location.pathname} robots="noindex, follow" />
    <div className="flex w-full max-w-sm flex-col gap-3">
      <Skeleton className="h-8 w-2/3" />
      <Skeleton className="h-48 w-full rounded-[var(--scaena-radius-surface)]" />
    </div>
  </div>
)

export default ScaenaRouter;
